import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { WHATSAPP_LINK } from '../lib/site';

const NotFound = () => {
  return (
    <div className="relative min-h-screen bg-paper text-ink grain">
      <SEO title="Página no encontrada" url="/404" noindex />
      <Header />
      <main className="pt-[140px] md:pt-[180px] pb-28 px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p className="stat-number text-[clamp(5rem,18vw,10rem)] text-paper-3 leading-none select-none">404</p>
          <h1 className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl mt-2">
            Esta página está <em className="font-serifit normal-case font-normal text-clay">en obras</em>
          </h1>
          <p className="mt-5 text-ink-soft leading-relaxed">
            La página que buscas no existe o se ha movido. Pero tu proyecto de reforma
            sí puede empezar hoy.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn bg-ink text-paper">Volver al inicio</Link>
            <a
              href={WHATSAPP_LINK('Hola, he encontrado un enlace roto en vuestra web y quiero información.')}
              target="_blank"
              rel="noopener noreferrer"
              className="btn border border-ink text-ink"
            >
              Hablar por WhatsApp
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
